import { NegativeStyle, NumberFormat, ThousandsSeparator } from "../../models/shared/formats/Number";
// DecimalCount
export const decimalCountByEncodedValue = {
  0: "default",
  16777216: 0,
  33554432: 1,
  50331648: 2,
  67108864: 3,
  83886080: 4,
  100663296: 5
};
export const encodedValueByDecimalCount = {
  0: 16777216,
  1: 33554432,
  2: 50331648,
  3: 67108864,
  4: 83886080,
  5: 100663296,
  default: 0
};

// ThousandsSeparator
export const thousandsSeparatorByEncodedValue = {
  0: ThousandsSeparator.NONE,
  16384: ThousandsSeparator.COMMA
};
export const encodedValueByThousandsSeparator = {
  [ThousandsSeparator.COMMA]: 16384,
  [ThousandsSeparator.NONE]: 0
};

// NumberFormat
export const numberFormatbyEncodedValue = {
  0: NumberFormat.NONE,
  4096: NumberFormat.NUMBER,
  8192: NumberFormat.CURRENCY,
  12288: NumberFormat.PERCENT
};
export const encodedValueByNumberFormat = {
  [NumberFormat.NUMBER]: 4096,
  [NumberFormat.CURRENCY]: 8192,
  [NumberFormat.PERCENT]: 12288,
  [NumberFormat.NONE]: 0
};

// NegativeStyle
export const negativeStyleByEncodedValue = {
  0: NegativeStyle.NONE,
  2097152: NegativeStyle.SIGN_BLACK,
  4194304: NegativeStyle.PAREN_BLACK,
  6291456: NegativeStyle.SIGN_RED,
  8388608: NegativeStyle.PAREN_RED
};
export const encodedValueByNegativeStyle = {
  [NegativeStyle.SIGN_BLACK]: 2097152,
  [NegativeStyle.PAREN_BLACK]: 4194304,
  [NegativeStyle.SIGN_RED]: 6291456,
  [NegativeStyle.PAREN_RED]: 8388608,
  [NegativeStyle.NONE]: 0
};

// Encode / Decode functions
export const decodeNumberFormat = formatLookup => {
  return {
    decimalCount: decimalCountByEncodedValue[formatLookup.decimalCount] !== undefined ? decimalCountByEncodedValue[formatLookup.decimalCount] : "default",
    negativeStyle: negativeStyleByEncodedValue[formatLookup.negativeStyle] || NegativeStyle.NONE,
    numberFormat: numberFormatbyEncodedValue[formatLookup.numberFormat] || NumberFormat.NONE,
    thousandsSeparator: thousandsSeparatorByEncodedValue[formatLookup.thousandsSeparator] || ThousandsSeparator.NONE
  };
};
export const encodeNumberFormat = decodedFormat => {
  return {
    decimalCount: encodedValueByDecimalCount[decodedFormat.decimalCount],
    negativeStyle: encodedValueByNegativeStyle[decodedFormat.negativeStyle],
    numberFormat: encodedValueByNumberFormat[decodedFormat.numberFormat],
    thousandsSeparator: encodedValueByThousandsSeparator[decodedFormat.thousandsSeparator]
  };
};
//# sourceMappingURL=Number.js.map